// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-styles-containers-___UserEditor__button___UGIGf {
  background-color: transparent;
  border: none;
  border-radius: 3px;
  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  color: #ffffff;
  padding: 0.75em 1em;
  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);
  transition: all 0.15s cubic-bezier(0.35, 0, 0.25, 1);
}
.src-styles-containers-___UserEditor__button___UGIGf.src-styles-containers-___UserEditor__success___Sjf04 {
  background-color: #4ca92f;
  color: #ffffff;
}
.src-styles-containers-___UserEditor__button___UGIGf.src-styles-containers-___UserEditor__success___Sjf04:hover {
  background-color: #3a8124;
  color: #ffffff;
}
.src-styles-containers-___UserEditor__button___UGIGf.src-styles-containers-___UserEditor__alert___p6bIO {
  background-color: #ff401e;
  color: #ffffff;
}
.src-styles-containers-___UserEditor__button___UGIGf.src-styles-containers-___UserEditor__alert___p6bIO:hover {
  background-color: #ea2400;
  color: #ffffff;
}
.src-styles-containers-___UserEditor__button___UGIGf:disabled,
.src-styles-containers-___UserEditor__button___UGIGf:disabled:hover {
  background-color: rgba(150, 150, 150, 0.5);
}
.src-styles-containers-___UserEditor__inputField___b54C8 {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
.src-styles-containers-___UserEditor__user--editor___zwSg9 {
  padding: 1em;
}
.src-styles-containers-___UserEditor__container___Z7pbe {
  height: 50px;
  display: flex;
  justify-content: flex-start;
}
.src-styles-containers-___UserEditor__container___Z7pbe > div {
  max-width: 600px;
  margin-top: auto;
  margin-bottom: auto;
  flex-grow: 5;
}
.src-styles-containers-___UserEditor__container___Z7pbe > input[type='checkbox'] {
  margin-right: 10px;
  margin-top: auto;
  margin-bottom: auto;
}
.src-styles-containers-___UserEditor__container___Z7pbe label {
  max-width: 100px;
  margin-right: 15px;
  margin-top: auto;
  margin-bottom: auto;
  flex-grow: 1;
}
.src-styles-containers-___UserEditor__hidden___QRu7x {
  display: none;
}
.src-styles-containers-___UserEditor__user--link___kU_NG {
  font-size: 1em;
  line-height: 0.5em;
  margin-left: 1em;
}
.src-styles-containers-___UserEditor__user--link___kU_NG i {
  vertical-align: middle;
}
.src-styles-containers-___UserEditor__input___zGObd {
  font-size: 1.5em;
  border: 1px solid rgba(150, 150, 150, 0.5);
  border-radius: 3px;
  padding: 0.2em;
  min-width: 300px;
  width: 100%;
}
.src-styles-containers-___UserEditor__save___o8wiW {
  margin-top: 1em;
}
.src-styles-containers-___UserEditor__delete-button___jUlud {
  margin-top: 1em;
  margin-left: 0.5em;
}
.errorMessage {
  margin-left: 0.5em;
  color: #ff401e;
}
div.src-styles-containers-___UserEditor__chartSelector___vLrWB {
  display: flex;
  justify-content: space-between;
}
`, "",{"version":3,"sources":["webpack://./src/styles/mixins.less","webpack://./src/styles/containers/UserEditor.less"],"names":[],"mappings":"AAEA;EACE,6BAAA;EACA,YAAA;EACA,kBAAA;EACA,0CAAA;EACA,cAAA;EACA,mBAAA;EACA,2CAAA;EACA,oDAAA;ACDF;ADGE;EACE,yBAAA;EACA,cAAA;ACDJ;ADGI;EACE,yBAAA;EACA,cAAA;ACDN;ADKE;EACE,yBAAA;EACA,cAAA;ACHJ;ADKI;EACE,yBAAA;EACA,cAAA;ACHN;ADOE;;EACE,0CAAA;ACJJ;ADQA;EACE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACNF;AAlCA;EACE,YAAA;AAoCF;AAjCA;EACE,YAAA;EACA,aAAA;EACA,2BAAA;AAmCF;AAtCA;EAMI,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAmCJ;AA5CA;EAaI,kBAAA;EACA,gBAAA;EACA,mBAAA;AAkCJ;AAjDA;EAmBI,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAiCJ;AA5BA;EACE,aAAA;AA8BF;AA3BA;EACE,cAAA;EACA,kBAAA;EACA,gBAAA;AA6BF;AAhCA;EAMI,sBAAA;AA6BJ;AAzBA;EDXE,gBAAA;EACA,0CAAA;EACA,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,WAAA;ACuCF;AA7BA;EACE,eAAA;AA+BF;AA5BA;EACE,eAAA;EACA,kBAAA;AA8BF;AA3BA;EAEI,kBAAA;EACA,cAAA;AA4BJ;AAxBA;EACE,aAAA;EACA,8BAAA;AA0BF","sourcesContent":["@import './variables.less';\n\n.button {\n  background-color: transparent;\n  border: none;\n  border-radius: 3px;\n  box-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  color: @color-main-white;\n  padding: 0.75em 1em;\n  text-shadow: 1px 1px 1px rgba(0, 0, 0, 0.2);\n  transition: @transition;\n  \n  &.success {\n    background-color: @color-main-green;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-green, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &.alert {\n    background-color: @color-main-red;\n    color: @color-main-white;\n\n    &:hover {\n      background-color: darken(@color-main-red, 10%);\n      color: @color-main-white;\n    }\n  }\n\n  &:disabled, &:disabled:hover {\n    background-color: @color-main-gray;\n  }\n}\n\n.inputField {\n  font-size: 1.5em;\n  border: 1px solid @color-main-gray;\n  border-radius: 3px;\n  padding: 0.2em;\n  min-width: 300px;\n  width: 100%;\n}\n","@import '../variables.less';\n@import '../mixins.less';\n\n.user--editor {\n  padding: 1em;\n}\n\n.container {\n  height: 50px;\n  display: flex;\n  justify-content: flex-start;   \n  \n  > div {\n    max-width: 600px;\n    margin-top: auto;\n    margin-bottom: auto; \n    flex-grow: 5;\n  }\n\n  > input[type='checkbox']  {\n    margin-right: 10px;\n    margin-top: auto;\n    margin-bottom: auto;\n  }\n\n  label {\n    max-width: 100px;    \n    margin-right: 15px; \n    margin-top: auto;\n    margin-bottom: auto;\n    flex-grow: 1; \n  }\n}\n\n\n.hidden {\n  display: none;\n}\n\n.user--link {\n  font-size: 1em;\n  line-height: 0.5em;\n  margin-left: 1em;\n\n  i {\n    vertical-align: middle;\n  }\n}\n\n.input {\n  .inputField();\n}\n\n.save {\n  margin-top: 1em;\n}\n\n.delete-button {\n  margin-top: 1em;\n  margin-left: 0.5em;\n}\n\n:global {\n  .errorMessage {\n    margin-left: 0.5em;\n    color: @color-main-red;\n  }\n}\n\ndiv.chartSelector  {\n  display: flex;\n  justify-content: space-between\n}\n"],"sourceRoot":""}]);
// Exports
export var button = `src-styles-containers-___UserEditor__button___UGIGf`;
export var success = `src-styles-containers-___UserEditor__success___Sjf04`;
export var alert = `src-styles-containers-___UserEditor__alert___p6bIO`;
export var inputField = `src-styles-containers-___UserEditor__inputField___b54C8`;
var _1 = `src-styles-containers-___UserEditor__user--editor___zwSg9`;
export { _1 as "user--editor" };
export var container = `src-styles-containers-___UserEditor__container___Z7pbe`;
export var hidden = `src-styles-containers-___UserEditor__hidden___QRu7x`;
var _2 = `src-styles-containers-___UserEditor__user--link___kU_NG`;
export { _2 as "user--link" };
export var input = `src-styles-containers-___UserEditor__input___zGObd`;
export var save = `src-styles-containers-___UserEditor__save___o8wiW`;
var _3 = `src-styles-containers-___UserEditor__delete-button___jUlud`;
export { _3 as "delete-button" };
export var chartSelector = `src-styles-containers-___UserEditor__chartSelector___vLrWB`;
export default ___CSS_LOADER_EXPORT___;
